@let localValoration = valorationDetail();
<div class="d-flex">
  <div class="d-flex gap-3 align-items-start">
    <img
      class="img-thumbnail object-fit-cover rounded-circle"
      [lazyLoad]="localValoration.user?.country?.icon | cdnUrl: 80 : true"
      [alt]="localValoration.user?.country?.name"
      width="30"
      height="30"
    />
    <div class="d-flex flex-column">
      <h5 class="mb-1 fw-bold fs-6">
        {{ `${localValoration.user?.first_name} ${localValoration.user?.last_name}` }}
      </h5>
      <p class="mb-0 fw-light">{{ localValoration.detail }}</p>
    </div>
  </div>

  <div class="text-end ms-auto">
    @let localDate = creationDate();
    @if (localDate) {
      <span timeago [date]="localDate.getTime()" class="user-time"></span>
    }
    @if (isAuthenticated ? user()?.id === localValoration?.user?.id : false) {
      <img
        [ngbPopover]="popContent"
        src="img/icons/dropdown_blue.png"
        class="align-baseline cursor-pointer"
      />
    }
  </div>
</div>

<ng-template #popContent>
  <div class="animated slideInDown">
    <a
      (click)="openEditValorationModal()"
      class="d-flex align-items-center a-nostyle d-block mb-3 cursor-pointer gap-2"
    >
      <i class="inm-icon-edit"></i>
      {{ 'editar' | translate | capitalize }}
    </a>
    <a (click)="deleteComment()" class="d-flex align-items-center a-nostyle cursor-pointer gap-2">
      <i class="inm-icon-delete fs-6 red-text"></i>
      {{ 'eliminar' | translate }}
    </a>
  </div>
</ng-template>
